import React from 'react';
import './offersProgress.scss';

import {Logout, statusOffertaProgress, prioritaOptions, IsRole_Admin, IsRole_Manager, IsRole_Operator} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  //Button,
  //Pager,
  //Paging,
  //FilterRow,
  HeaderFilter,
  Lookup,
  Editing,
  Selection,
  Toolbar,
  Item,
  Summary,
  //GroupItem,
  TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';

import { useState, useEffect, useCallback } from "react";
//import { Toolbar, Item } from 'devextreme-react';

import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Offerte'

const debug = process.env.ENTITY_DEBUG;

export default function OffersProgress(props) {

  const [stati, setStati] = useState({});
  const [clienti, setClienti] = useState({});
  const [collaboratori, setCollaboratori] = useState({});
  const [concorrenti, setConcorrenti] = useState({});
  const [intermediari, setIntermediari] = useState({});
  const [tipiSoggetto, setTipiSoggetto] = useState({});
  const [tipiOfferta, setTipiOfferta] = useState({});
  const [categorieOfferta, setCategorieOfferta] = useState({});
  const [anni, setAnni] = useState({});

  const [annoFilter, setAnnoFilter] = useState(new Date().getFullYear());
  const [intermediarioFilter, setIntermediarioFilter] = useState(210);
  const [statoFilter, setStatoFilter] = useState();
  const [managerFilter, setManagerFilter] = useState();
  const [tipoFilter, setTipoFilter] = useState();
  const [prioritaFilter, setPrioritaFilter] = useState();
  const [categoriaFilter, setCategoriaFilter] = useState();

  const filterPayload = { 
    //storico: isStorico,
    anno: annoFilter,
    intermediario: intermediarioFilter,
    stato: statoFilter,
    manager: managerFilter,
    tipo: tipoFilter,
    priorita: prioritaFilter,
    categoria: categoriaFilter
  };

  const { user } = useAuth(); 

  if (!user) 
    Logout();

  const remoteDataSource = createStore({
    key: 'id',
    loadUrl: serviceUrl + '/FindProgress',
    //insertUrl: serviceUrl + '/InsertAction',
    //updateUrl:serviceUrl + '/UpdateAction',
    //deleteUrl: serviceUrl + '/DeleteAction'
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
          var payload = ajaxOptions.data;
          payload.values = JSON.stringify(filterPayload);
          ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
  });

  useEffect(() => {

    const fetchData = async () => {

      const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaStato';
      var newUrl =  newServiceUrl + "/GetAction";

      // const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      // var newUrl2 =  newServiceUrl2 + "/GetClienti";

      const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Collaboratore';
      var newUrl3 =  newServiceUrl3 + "/GetCollaboratori";

      // const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Valuta';
      // var newUrl4 =  newServiceUrl4 + "/GetAction";

      // const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ModalitaPagamento';
      // var newUrl5 =  newServiceUrl5 + "/GetAction";

      // const newServiceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CondizioniPagamento';
      // var newUrl6 =  newServiceUrl6 + "/GetAction";

      const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl7 =  newServiceUrl7 + "/GetIntermediari";

      const newServiceUrl8 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoSoggetto';
      var newUrl8 =  newServiceUrl8 + "/GetAction";

      const newServiceUrl9 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_AnniOfferte';
      var newUrl9 =  newServiceUrl9 + "/GetAction";

      const newServiceUrl12 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaTipo';
      var newUrl12 =  newServiceUrl12 + "/GetAction";

      const newServiceUrl13 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaCategoria';
      var newUrl13 =  newServiceUrl13 + "/GetAction";



      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const response = await fetch(newUrl);
        const json = await response.json();
        if (debug === 1)
          console.log(json);
        setStati(json);

        // const response2 = await fetch(newUrl2);
        // const json2 = await response2.json();
        // if (debug === 1)
        //   console.log(json2);
        // setClienti(json2);

        const response3 = await fetch(newUrl3,requestOptions);
        const json3 = await response3.json();
        if (debug === 1)
          console.log(json3);
        setCollaboratori(json3);

        // const response4 = await fetch(newUrl4);
        // const json4 = await response4.json();
        // if (debug === 1)
        //   console.log(json4);
        // setValute(json4);

        // const response5 = await fetch(newUrl5);
        // const json5 = await response5.json();
        // if (debug === 1)
        //   console.log(json5);
        // setModalitaPagam(json5);

        // const response6 = await fetch(newUrl6);
        // const json6 = await response6.json();
        // if (debug === 1)
        //   console.log(json6);
        // setCondizioniPagam(json6);

        const response7 = await fetch(newUrl7,requestOptions);
        const json7 = await response7.json();
        if (debug === 1)
          console.log(json7);
        setIntermediari(json7);

        const response8 = await fetch(newUrl8);
        const json8 = await response8.json();
        if (debug === 1)
          console.log(json8);
        setTipiSoggetto(json8);

        const response9 = await fetch(newUrl9);
        const json9 = await response9.json();
        if (debug === 1)
          console.log(json9);
        setAnni(json9);

        // const response10 = await fetch(newUrl10);
        // const json10 = await response10.json();
        // if (debug === 1)
        //   console.log(json10);
        // setStatoCausali(json10);

        // const response11 = await fetch(newUrl11);
        // const json11 = await response11.json();
        // if (debug === 1)
        //   console.log(json11);
        // setConcorrenti(json11);

        const response12 = await fetch(newUrl12);
        const json12 = await response12.json();
        if (debug === 1)
          console.log(json12);
        setTipiOfferta(json12);

        const response13 = await fetch(newUrl13);
        const json13 = await response13.json();
        if (debug === 1)
          console.log(json13);
        setCategorieOfferta(json13);

      } catch (error) {
        console.log("error", error);
      }
    };

    fetchData();
  }, []);

  function customizeText(data) {
    return `Offerte: ${data.value}`;
  }

  const selectBoxOptions = {
    width: 150,
    items: anni,
    valueExpr: 'id',
    displayExpr: 'annoDoc',
    onValueChanged: (args) => {
      setAnnoFilter(args.value);
    },
    value: annoFilter
  };
  
  const selectBoxOptions2 = {
    width: 210,
    items: intermediari,
    valueExpr: 'id',
    displayExpr: 'ragioneSociale',
    placeholder:"<Azienda>",
    showClearButton:true,
    onValueChanged: (args) => {
      setIntermediarioFilter(args.value);
    },
    value: intermediarioFilter,
  };
  
  const selectBoxOptions3 = {
    width: 180,
    items: stati,
    valueExpr: 'id',
    displayExpr: 'nome',
    placeholder:"<Stato>",
    showClearButton:true,
    onValueChanged: (args) => {
      setStatoFilter(args.value);
    },
    value: statoFilter
  };

  const selectBoxOptions4 = {
    width: 180,
    items: collaboratori,
    valueExpr: 'id',
    displayExpr: 'cognome',
    placeholder:"<Manager/Deputy>",
    showClearButton:true,
    onValueChanged: (args) => {
      setManagerFilter(args.value);
    },
    value: managerFilter
  };

  const selectBoxOptions5 = {
    width: 150,
    items: tipiOfferta,
    valueExpr: 'id',
    displayExpr: 'nome',
    placeholder:"<Tipo>",
    showClearButton:true,
    onValueChanged: (args) => {
      setTipoFilter(args.value);
    },
    value: tipoFilter,
  };

  const selectBoxOptions6 = {
    width: 150,
    items: prioritaOptions,
    valueExpr: 'id',
    displayExpr: 'desc',
    placeholder:"<Priorità>",
    showClearButton:true,
    onValueChanged: (args) => {
      setPrioritaFilter(args.value);
    },
    value: prioritaFilter,
  };

  const selectBoxOptions7 = {
    width: 150,
    items: categorieOfferta,
    valueExpr: 'id',
    displayExpr: 'nome',
    placeholder:"<Categoria>",
    showClearButton:true,
    onValueChanged: (args) => {
      setCategoriaFilter(args.value);
    },
    value: categoriaFilter,
  };

  function onToolbarPreparing(e) {
   
    e.toolbarOptions.items.push({
      widget: 'dxButton',
      name: "myexport",
      location: "before",
      options: {
          icon: "exportxlsx",
          hint: "Esporta in Excel",
          onClick: function() {
            onExporting(e);
          }
      }
    });

  }
  
  function onExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Avanzamento Offerte');
  
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Avanzamento_Offerte.xlsx');
      });
    });
    e.cancel = true;
  }

return (
  <React.Fragment>
    <h2 className={'content-block'}>Avanzamento Offerte</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        <DataGrid
          dataSource={remoteDataSource}
          focusedRowEnabled={true}
          columnHidingEnabled={true}
          showBorders={true}
          onExporting={onExporting}
          onToolbarPreparing = {onToolbarPreparing}
          onCellPrepared={statusOffertaProgress}
        >
          <SearchPanel visible={true} width={240} placeholder="Cerca..." />
          <Toolbar>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions} >
            </Item>
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions2} >
            </Item>
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions6} >
            </Item>
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions5} >
            </Item>
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions7} >
            </Item>
           
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions4} >
            </Item>
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions3} >
            </Item>
            <Item name="searchPanel" className="offer-toolbar"/>

         </Toolbar>
         <HeaderFilter visible={true} />
          <Summary>
            <TotalItem
                column="oggetto"
                summaryType="count"
                customizeText={customizeText}
            />
          </Summary>
        <Selection mode="single" />
        <Editing
          mode="row"
          useIcons={true}
          allowAdding={false}
          allowDeleting={false}
          allowUpdating={false}     
        />
        <Column dataField="id" visible={false}/>
        <Column dataField="oggetto" caption="Progetto" width={320}/>
        <Column dataField="intermediarioId" caption="Azienda"  width={80} visible={false}>
          <Lookup dataSource={intermediari} valueExpr="id" displayExpr="alias" />
        </Column>
        <Column dataField="numero" width={80}/>
        <Column dataField="cliente" />
        <Column dataField="destinazione" />
        <Column dataField="localita" caption="Località" visible={false}/>
        <Column dataField="dataScadenzaPresentazione" dataType="date" format= {'dd/MM/yyyy'} caption="Scadenza Presentazione" width={130} />
      
        <Column dataField="prioritaId"  width={80} caption="Priorità">
          <Lookup dataSource={prioritaOptions} displayExpr="desc" valueExpr="id" />
        </Column>
        <Column dataField="tipoId" caption="Tipo" width={120} visible={true}>
          <Lookup dataSource={tipiOfferta} valueExpr="id" displayExpr="nome" />
        </Column>  
        <Column dataField="categoriaId" caption="Categoria" width={80} visible={true}>
          <Lookup dataSource={categorieOfferta} valueExpr="id" displayExpr="nome" />
        </Column>
        <Column dataField="riferimentoInternoId" caption="Manager" width={120}>
          <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
        </Column>
        <Column dataField="riferimentoInterno2Id" caption="Deputy" width={120} visible={true}>
          <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
        </Column> 
        <Column dataField="statoId" caption="Stato" width={110}>
          <Lookup dataSource={stati} valueExpr="id" displayExpr="nome" />
        </Column>
        <Column dataField="createDate" caption="Data Protocollo" dataType="date" format= {'dd/MM/yyyy'} />
        <Column dataField="dataInvio" dataType="date" format= {'dd/MM/yyyy'} caption="Data Invio" width={130} />
   
   
        <Column dataField="riferimentoCliente" caption="Riferimento Cliente"/>
        <Column dataField="emailRiferimento" />
        <Column dataField="telefonoRiferimento"/>
        <Column dataField="descrizione" caption="Note" width={200}/>
        <Column dataField="linkDocumenti" caption="Link Documentazione"/>
        
      </DataGrid>  
      </div>
    </div>
  </React.Fragment>
)};

